<!--
    描述：会议室申请记录
    Created by asq
-->

<template>
	<div class="h100 meeting-apply">
	  <filter-layout
		@search="searchResult"
		@reset="resetSerach"
		v-if="!routeQuery"
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchRef"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="会议室名称">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.sname"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="归属场地：" prop="siteName">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchForm.siteName"
				size="small"
			  ></el-input>
			</el-form-item>
			<el-form-item label="会议室类型：">
			  <el-select
				v-model="searchForm.type"
				placeholder="请选择"
				size="small"
			  >
				<el-option
				  v-for="item in hyslx"
				  :key="item.value"
				  :label="item.sname"
				  :value="item.value"
				>
				</el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  合计场地预约记录： <span class="blue">{{ total }}</span> 条
			</div>
			<div class="mt10 mb10 fr">
			  <!-- <el-button type="primary" class="btn-blue" size="small" @click="changeState">
					  筛选
					  <i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
					  <i v-else class="el-icon-caret-top ml5"></i>
				  </el-button> -->
			  <el-button
				size="small"
				class="btn-blue"
				icon="el-icon-refresh"
				type="primary"
				@click="resetSerach"
			  ></el-button>
			</div>
		  </div>
		  <div class="operation-container w-table-layout w-table-page">
			<div class="w-table-content" v-show="tableShow">
			  <el-table
				ref="xTable"
				highlight-current-row
				:data="filterData"
				height="100%"
				border
			  >
				<el-table-column
				  type="index"
				  label="序号"
				  align="center"
				  width="100"
				></el-table-column>
				<el-table-column
				  prop="sname"
				  label="会议室名称"
				  header-align="center"
				  width="310"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="typeName"
				  label="会议室类型"
				  header-align="center"
				  min-width="200"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="placeName"
				  label="归属场地"
				  header-align="center"
				  min-width="350"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="usedCount"
				  label="已使用次数"
				  align="center"
				  width="200"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="appointmentCount"
				  label="目前预约中"
				  align="center"
				  width="200"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column align="center" width="100">
				  <template slot="header">操作</template>
				  <template slot-scope="scope">
					<el-button
					  type="primary"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  v-if="roleBtns.includes('statisticsDetail')"
					  @click="recordsDetail(scope)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageList"
				:page-size="pageSize"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="h100" v-if="routeQuery">
		<records-detail :childObj="childObj"></records-detail>
	  </div>
	</div>
  </template>
<script>
import {
	getOperateSiteList,
	getOperateTenantMapList,
	getPageMeeting,
} from "api/modules/fieldManagement";
import { mapState } from "vuex";

import RecordsDetail from "./components/records-detail";

export default {
	name: 'Room-records',
	components: {
		RecordsDetail,
	},
	data() {
		return {
			filterData: [],
			searchForm: {
				sname: '', // 会议室名称
				siteName: '', // 场地归属 名称
				type: '', //会议室类型
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true,
			departmentList: [], // 场地所属单位列表
			childObj: {},
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(
					this.$getSessionItem('currentPage')
				)

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}

		this.getData()
	},
	methods: {
		//重置筛选框
		resetSerach() {
			this.searchForm = {}
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},

		//查看明细
		recordsDetail(params) {
			this.childObj = params.row
			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.currentPage)
			)
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				name: 'Room-records',
				query: {
					type: 'detail',
				},
			})
		},

		// 获取所属单位
		getDepartments() {
			getOperateTenantMapList().then((d) => {
				if (d.code == 0) {
					this.departmentList = d.data
				}
			})
		},

		//获得归属场地列表
		getUnitData() {
			this.loading = true
			getOperateSiteList({
				unit: '',
				tag: '',
			})
				.then((res) => {
					this.departmentList = res.data
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//获得列表数据
		getData() {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize

			getPageMeeting(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//筛选框重置
		handleClose() {
			this.dialogObj.visible = false
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 搜索
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},
	},

	computed: {
		...mapState('place_dict', { hyslx: (state) => state.hyslx }),
		...mapState('app', {
			isBack: (state) => state.isBack,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		routeQuery() {
			return this.$route.query.type
		},
	},

	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		},
	},
}
</script>

<style lang="less" scoped>
.meeting-apply {
	.filter-box {
		padding: 8px;
	}

	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.mb10 {
		margin-bottom: 10px;
	}

	.blue {
		color: #2671cc;
		cursor: pointer;
	}
	.content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
		  padding-left: 10px;
		  border-left: 4px solid #2671cc;
		  font-size: 14px;
		  color: #202020;
		}
		.blue{
		  font-size: 18px;
		  color: #2671cc;
		}
	  }
}
</style>
